import cn from 'classnames';

const XCircle = ({ className = '' }) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" className={cn('icon', className)}>
    <rect x="0.5" y="0.5" width="23" height="23" rx="11.5" fill="currentColor" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.9898 12L7.20921 8.21936C6.93026 7.94042 6.93026 7.48816 7.20921 7.20921C7.48816 6.93026 7.94042 6.93026 8.21936 7.20921L12 10.9898L15.7806 7.20921C16.0596 6.93026 16.5118 6.93026 16.7908 7.20921C17.0697 7.48816 17.0697 7.94042 16.7908 8.21936L13.0102 12L16.7908 15.7806C17.0697 16.0596 17.0697 16.5118 16.7908 16.7908C16.5118 17.0697 16.0596 17.0697 15.7806 16.7908L12 13.0102L8.21936 16.7908C7.94042 17.0697 7.48816 17.0697 7.20921 16.7908C6.93026 16.5118 6.93026 16.0596 7.20921 15.7806L10.9898 12Z"
      fill="white"
    />
    <rect x="0.5" y="0.5" width="23" height="23" rx="11.5" stroke="currentColor" />
  </svg>
);

XCircle.propTypes = {
  className: PropTypes.string,
};

export default XCircle;
